export type BringgFontIconsId =
  | "accelerate"
  | "add-location-alt"
  | "alt-route"
  | "analytics-chart"
  | "analytics"
  | "area-chart"
  | "arrow-down"
  | "arrow-left"
  | "arrow-right"
  | "arrow-up"
  | "arrow"
  | "arrows-up-down"
  | "attachment"
  | "auto-stories"
  | "autopay"
  | "bars-filter"
  | "battery-full"
  | "battery-ver-empty"
  | "battery-ver-half"
  | "battery-ver-quarter"
  | "battery-ver-three-quarters"
  | "bicycle"
  | "block"
  | "break-to"
  | "bringg"
  | "bullseye"
  | "bus"
  | "busket"
  | "cafe-solid"
  | "cafe"
  | "calendar"
  | "campaign"
  | "cancel"
  | "car"
  | "cart"
  | "cashier"
  | "chat-bubble"
  | "chat-bubbles"
  | "checklist"
  | "chevron-left"
  | "chevron-right"
  | "chevron-up"
  | "chevron"
  | "chevrons-end"
  | "chevrons-start"
  | "circle-exclamation"
  | "circle"
  | "clock-light"
  | "clock"
  | "close-circle"
  | "close"
  | "coins"
  | "colorize"
  | "columns"
  | "compass"
  | "completed"
  | "connected-hub"
  | "control-tower"
  | "copy"
  | "credit-card"
  | "crew"
  | "csv-file"
  | "cube"
  | "customer-sdk"
  | "customer"
  | "cutoff"
  | "delivery-slots"
  | "deployed-code-history"
  | "design-services"
  | "distance"
  | "distribution-hub"
  | "documenatation-link"
  | "dot"
  | "download"
  | "drag"
  | "driver-home"
  | "drivers-returning-to-base"
  | "drivers"
  | "dropoff"
  | "eco"
  | "edit-square"
  | "erase"
  | "event-available"
  | "expenses"
  | "export"
  | "external-link"
  | "eye-off"
  | "eye"
  | "feather"
  | "file-alt"
  | "file-import"
  | "file"
  | "filter-hdr"
  | "filter-list"
  | "flat-tire"
  | "floating-inventory"
  | "fork-left-right-back"
  | "forward"
  | "fragile"
  | "freeze"
  | "functions"
  | "globe"
  | "go-to-link"
  | "graph"
  | "group-by"
  | "hamburger"
  | "hand-pan-move"
  | "hand-pointing-up"
  | "headset"
  | "heart-filled"
  | "heart"
  | "help"
  | "home"
  | "hourglass"
  | "hub"
  | "info-filled"
  | "info"
  | "inventory"
  | "json"
  | "keyboard"
  | "launch"
  | "layers"
  | "leaf-eco"
  | "library-books"
  | "link"
  | "list"
  | "loader"
  | "local-police"
  | "local-shipping"
  | "location"
  | "lock"
  | "locker"
  | "logout"
  | "man"
  | "manage-history"
  | "map-task"
  | "map"
  | "maximize"
  | "menu-horizontal"
  | "menu"
  | "message-mail"
  | "minimize"
  | "minus"
  | "monitor"
  | "my-location"
  | "navigation-up"
  | "navigation"
  | "note-light"
  | "notes"
  | "notification"
  | "open-in-new"
  | "optimize"
  | "order"
  | "ordered-list"
  | "package"
  | "pallets"
  | "parking-location"
  | "partner-exchange"
  | "pause"
  | "pdf-file"
  | "pencil"
  | "phone-android"
  | "phone"
  | "pickup"
  | "planning"
  | "play"
  | "plus"
  | "power"
  | "preferences"
  | "preparation-restaurant"
  | "preperation"
  | "print"
  | "promped-message"
  | "puzzle"
  | "radar"
  | "recipt"
  | "redo-arrow"
  | "redo"
  | "report"
  | "reschedule"
  | "revenues"
  | "reviews"
  | "rotate"
  | "route"
  | "ruler"
  | "save-as"
  | "save"
  | "scanner"
  | "search"
  | "selected-outline"
  | "selected"
  | "send"
  | "settings-suggest"
  | "settings"
  | "share"
  | "sheet-with-dollar"
  | "shield-person"
  | "show-less"
  | "show-more"
  | "small-circle"
  | "sort-asc"
  | "sort-desc"
  | "star"
  | "sticky-note"
  | "stop-circle"
  | "store"
  | "suffix"
  | "suitcase"
  | "support"
  | "takeout-dining"
  | "task-alt"
  | "team-home"
  | "team-parking"
  | "team"
  | "text-bold"
  | "text-italic"
  | "text-underline"
  | "ticket"
  | "traffic"
  | "trailer"
  | "trash"
  | "tree"
  | "truck"
  | "unassigned"
  | "unavailable"
  | "undo-arrow"
  | "undo"
  | "unuser"
  | "user"
  | "users"
  | "verification-code"
  | "warehouse"
  | "warning-circle"
  | "warning-not-filled"
  | "warning"
  | "weight"
  | "wheel"
  | "zoom-in"
  | "zoom-out";

export type BringgFontIconsKey =
  | "Accelerate"
  | "AddLocationAlt"
  | "AltRoute"
  | "AnalyticsChart"
  | "Analytics"
  | "AreaChart"
  | "ArrowDown"
  | "ArrowLeft"
  | "ArrowRight"
  | "ArrowUp"
  | "Arrow"
  | "ArrowsUpDown"
  | "Attachment"
  | "AutoStories"
  | "Autopay"
  | "BarsFilter"
  | "BatteryFull"
  | "BatteryVerEmpty"
  | "BatteryVerHalf"
  | "BatteryVerQuarter"
  | "BatteryVerThreeQuarters"
  | "Bicycle"
  | "Block"
  | "BreakTo"
  | "Bringg"
  | "Bullseye"
  | "Bus"
  | "Busket"
  | "CafeSolid"
  | "Cafe"
  | "Calendar"
  | "Campaign"
  | "Cancel"
  | "Car"
  | "Cart"
  | "Cashier"
  | "ChatBubble"
  | "ChatBubbles"
  | "Checklist"
  | "ChevronLeft"
  | "ChevronRight"
  | "ChevronUp"
  | "Chevron"
  | "ChevronsEnd"
  | "ChevronsStart"
  | "CircleExclamation"
  | "Circle"
  | "ClockLight"
  | "Clock"
  | "CloseCircle"
  | "Close"
  | "Coins"
  | "Colorize"
  | "Columns"
  | "Compass"
  | "Completed"
  | "ConnectedHub"
  | "ControlTower"
  | "Copy"
  | "CreditCard"
  | "Crew"
  | "CsvFile"
  | "Cube"
  | "CustomerSdk"
  | "Customer"
  | "Cutoff"
  | "DeliverySlots"
  | "DeployedCodeHistory"
  | "DesignServices"
  | "Distance"
  | "DistributionHub"
  | "DocumenatationLink"
  | "Dot"
  | "Download"
  | "Drag"
  | "DriverHome"
  | "DriversReturningToBase"
  | "Drivers"
  | "Dropoff"
  | "Eco"
  | "EditSquare"
  | "Erase"
  | "EventAvailable"
  | "Expenses"
  | "Export"
  | "ExternalLink"
  | "EyeOff"
  | "Eye"
  | "Feather"
  | "FileAlt"
  | "FileImport"
  | "File"
  | "FilterHdr"
  | "FilterList"
  | "FlatTire"
  | "FloatingInventory"
  | "ForkLeftRightBack"
  | "Forward"
  | "Fragile"
  | "Freeze"
  | "Functions"
  | "Globe"
  | "GoToLink"
  | "Graph"
  | "GroupBy"
  | "Hamburger"
  | "HandPanMove"
  | "HandPointingUp"
  | "Headset"
  | "HeartFilled"
  | "Heart"
  | "Help"
  | "Home"
  | "Hourglass"
  | "Hub"
  | "InfoFilled"
  | "Info"
  | "Inventory"
  | "Json"
  | "Keyboard"
  | "Launch"
  | "Layers"
  | "LeafEco"
  | "LibraryBooks"
  | "Link"
  | "List"
  | "Loader"
  | "LocalPolice"
  | "LocalShipping"
  | "Location"
  | "Lock"
  | "Locker"
  | "Logout"
  | "Man"
  | "ManageHistory"
  | "MapTask"
  | "Map"
  | "Maximize"
  | "MenuHorizontal"
  | "Menu"
  | "MessageMail"
  | "Minimize"
  | "Minus"
  | "Monitor"
  | "MyLocation"
  | "NavigationUp"
  | "Navigation"
  | "NoteLight"
  | "Notes"
  | "Notification"
  | "OpenInNew"
  | "Optimize"
  | "Order"
  | "OrderedList"
  | "Package"
  | "Pallets"
  | "ParkingLocation"
  | "PartnerExchange"
  | "Pause"
  | "PdfFile"
  | "Pencil"
  | "PhoneAndroid"
  | "Phone"
  | "Pickup"
  | "Planning"
  | "Play"
  | "Plus"
  | "Power"
  | "Preferences"
  | "PreparationRestaurant"
  | "Preperation"
  | "Print"
  | "PrompedMessage"
  | "Puzzle"
  | "Radar"
  | "Recipt"
  | "RedoArrow"
  | "Redo"
  | "Report"
  | "Reschedule"
  | "Revenues"
  | "Reviews"
  | "Rotate"
  | "Route"
  | "Ruler"
  | "SaveAs"
  | "Save"
  | "Scanner"
  | "Search"
  | "SelectedOutline"
  | "Selected"
  | "Send"
  | "SettingsSuggest"
  | "Settings"
  | "Share"
  | "SheetWithDollar"
  | "ShieldPerson"
  | "ShowLess"
  | "ShowMore"
  | "SmallCircle"
  | "SortAsc"
  | "SortDesc"
  | "Star"
  | "StickyNote"
  | "StopCircle"
  | "Store"
  | "Suffix"
  | "Suitcase"
  | "Support"
  | "TakeoutDining"
  | "TaskAlt"
  | "TeamHome"
  | "TeamParking"
  | "Team"
  | "TextBold"
  | "TextItalic"
  | "TextUnderline"
  | "Ticket"
  | "Traffic"
  | "Trailer"
  | "Trash"
  | "Tree"
  | "Truck"
  | "Unassigned"
  | "Unavailable"
  | "UndoArrow"
  | "Undo"
  | "Unuser"
  | "User"
  | "Users"
  | "VerificationCode"
  | "Warehouse"
  | "WarningCircle"
  | "WarningNotFilled"
  | "Warning"
  | "Weight"
  | "Wheel"
  | "ZoomIn"
  | "ZoomOut";

export enum BringgFontIcons {
  Accelerate = "accelerate",
  AddLocationAlt = "add-location-alt",
  AltRoute = "alt-route",
  AnalyticsChart = "analytics-chart",
  Analytics = "analytics",
  AreaChart = "area-chart",
  ArrowDown = "arrow-down",
  ArrowLeft = "arrow-left",
  ArrowRight = "arrow-right",
  ArrowUp = "arrow-up",
  Arrow = "arrow",
  ArrowsUpDown = "arrows-up-down",
  Attachment = "attachment",
  AutoStories = "auto-stories",
  Autopay = "autopay",
  BarsFilter = "bars-filter",
  BatteryFull = "battery-full",
  BatteryVerEmpty = "battery-ver-empty",
  BatteryVerHalf = "battery-ver-half",
  BatteryVerQuarter = "battery-ver-quarter",
  BatteryVerThreeQuarters = "battery-ver-three-quarters",
  Bicycle = "bicycle",
  Block = "block",
  BreakTo = "break-to",
  Bringg = "bringg",
  Bullseye = "bullseye",
  Bus = "bus",
  Busket = "busket",
  CafeSolid = "cafe-solid",
  Cafe = "cafe",
  Calendar = "calendar",
  Campaign = "campaign",
  Cancel = "cancel",
  Car = "car",
  Cart = "cart",
  Cashier = "cashier",
  ChatBubble = "chat-bubble",
  ChatBubbles = "chat-bubbles",
  Checklist = "checklist",
  ChevronLeft = "chevron-left",
  ChevronRight = "chevron-right",
  ChevronUp = "chevron-up",
  Chevron = "chevron",
  ChevronsEnd = "chevrons-end",
  ChevronsStart = "chevrons-start",
  CircleExclamation = "circle-exclamation",
  Circle = "circle",
  ClockLight = "clock-light",
  Clock = "clock",
  CloseCircle = "close-circle",
  Close = "close",
  Coins = "coins",
  Colorize = "colorize",
  Columns = "columns",
  Compass = "compass",
  Completed = "completed",
  ConnectedHub = "connected-hub",
  ControlTower = "control-tower",
  Copy = "copy",
  CreditCard = "credit-card",
  Crew = "crew",
  CsvFile = "csv-file",
  Cube = "cube",
  CustomerSdk = "customer-sdk",
  Customer = "customer",
  Cutoff = "cutoff",
  DeliverySlots = "delivery-slots",
  DeployedCodeHistory = "deployed-code-history",
  DesignServices = "design-services",
  Distance = "distance",
  DistributionHub = "distribution-hub",
  DocumenatationLink = "documenatation-link",
  Dot = "dot",
  Download = "download",
  Drag = "drag",
  DriverHome = "driver-home",
  DriversReturningToBase = "drivers-returning-to-base",
  Drivers = "drivers",
  Dropoff = "dropoff",
  Eco = "eco",
  EditSquare = "edit-square",
  Erase = "erase",
  EventAvailable = "event-available",
  Expenses = "expenses",
  Export = "export",
  ExternalLink = "external-link",
  EyeOff = "eye-off",
  Eye = "eye",
  Feather = "feather",
  FileAlt = "file-alt",
  FileImport = "file-import",
  File = "file",
  FilterHdr = "filter-hdr",
  FilterList = "filter-list",
  FlatTire = "flat-tire",
  FloatingInventory = "floating-inventory",
  ForkLeftRightBack = "fork-left-right-back",
  Forward = "forward",
  Fragile = "fragile",
  Freeze = "freeze",
  Functions = "functions",
  Globe = "globe",
  GoToLink = "go-to-link",
  Graph = "graph",
  GroupBy = "group-by",
  Hamburger = "hamburger",
  HandPanMove = "hand-pan-move",
  HandPointingUp = "hand-pointing-up",
  Headset = "headset",
  HeartFilled = "heart-filled",
  Heart = "heart",
  Help = "help",
  Home = "home",
  Hourglass = "hourglass",
  Hub = "hub",
  InfoFilled = "info-filled",
  Info = "info",
  Inventory = "inventory",
  Json = "json",
  Keyboard = "keyboard",
  Launch = "launch",
  Layers = "layers",
  LeafEco = "leaf-eco",
  LibraryBooks = "library-books",
  Link = "link",
  List = "list",
  Loader = "loader",
  LocalPolice = "local-police",
  LocalShipping = "local-shipping",
  Location = "location",
  Lock = "lock",
  Locker = "locker",
  Logout = "logout",
  Man = "man",
  ManageHistory = "manage-history",
  MapTask = "map-task",
  Map = "map",
  Maximize = "maximize",
  MenuHorizontal = "menu-horizontal",
  Menu = "menu",
  MessageMail = "message-mail",
  Minimize = "minimize",
  Minus = "minus",
  Monitor = "monitor",
  MyLocation = "my-location",
  NavigationUp = "navigation-up",
  Navigation = "navigation",
  NoteLight = "note-light",
  Notes = "notes",
  Notification = "notification",
  OpenInNew = "open-in-new",
  Optimize = "optimize",
  Order = "order",
  OrderedList = "ordered-list",
  Package = "package",
  Pallets = "pallets",
  ParkingLocation = "parking-location",
  PartnerExchange = "partner-exchange",
  Pause = "pause",
  PdfFile = "pdf-file",
  Pencil = "pencil",
  PhoneAndroid = "phone-android",
  Phone = "phone",
  Pickup = "pickup",
  Planning = "planning",
  Play = "play",
  Plus = "plus",
  Power = "power",
  Preferences = "preferences",
  PreparationRestaurant = "preparation-restaurant",
  Preperation = "preperation",
  Print = "print",
  PrompedMessage = "promped-message",
  Puzzle = "puzzle",
  Radar = "radar",
  Recipt = "recipt",
  RedoArrow = "redo-arrow",
  Redo = "redo",
  Report = "report",
  Reschedule = "reschedule",
  Revenues = "revenues",
  Reviews = "reviews",
  Rotate = "rotate",
  Route = "route",
  Ruler = "ruler",
  SaveAs = "save-as",
  Save = "save",
  Scanner = "scanner",
  Search = "search",
  SelectedOutline = "selected-outline",
  Selected = "selected",
  Send = "send",
  SettingsSuggest = "settings-suggest",
  Settings = "settings",
  Share = "share",
  SheetWithDollar = "sheet-with-dollar",
  ShieldPerson = "shield-person",
  ShowLess = "show-less",
  ShowMore = "show-more",
  SmallCircle = "small-circle",
  SortAsc = "sort-asc",
  SortDesc = "sort-desc",
  Star = "star",
  StickyNote = "sticky-note",
  StopCircle = "stop-circle",
  Store = "store",
  Suffix = "suffix",
  Suitcase = "suitcase",
  Support = "support",
  TakeoutDining = "takeout-dining",
  TaskAlt = "task-alt",
  TeamHome = "team-home",
  TeamParking = "team-parking",
  Team = "team",
  TextBold = "text-bold",
  TextItalic = "text-italic",
  TextUnderline = "text-underline",
  Ticket = "ticket",
  Traffic = "traffic",
  Trailer = "trailer",
  Trash = "trash",
  Tree = "tree",
  Truck = "truck",
  Unassigned = "unassigned",
  Unavailable = "unavailable",
  UndoArrow = "undo-arrow",
  Undo = "undo",
  Unuser = "unuser",
  User = "user",
  Users = "users",
  VerificationCode = "verification-code",
  Warehouse = "warehouse",
  WarningCircle = "warning-circle",
  WarningNotFilled = "warning-not-filled",
  Warning = "warning",
  Weight = "weight",
  Wheel = "wheel",
  ZoomIn = "zoom-in",
  ZoomOut = "zoom-out",
}

export const BRINGG_FONT_ICONS_CODEPOINTS: { [key in BringgFontIcons]: string } = {
  [BringgFontIcons.Accelerate]: "61697",
  [BringgFontIcons.AddLocationAlt]: "61698",
  [BringgFontIcons.AltRoute]: "61699",
  [BringgFontIcons.AnalyticsChart]: "61700",
  [BringgFontIcons.Analytics]: "61701",
  [BringgFontIcons.AreaChart]: "61702",
  [BringgFontIcons.ArrowDown]: "61703",
  [BringgFontIcons.ArrowLeft]: "61704",
  [BringgFontIcons.ArrowRight]: "61705",
  [BringgFontIcons.ArrowUp]: "61706",
  [BringgFontIcons.Arrow]: "61707",
  [BringgFontIcons.ArrowsUpDown]: "61708",
  [BringgFontIcons.Attachment]: "61709",
  [BringgFontIcons.AutoStories]: "61710",
  [BringgFontIcons.Autopay]: "61711",
  [BringgFontIcons.BarsFilter]: "61712",
  [BringgFontIcons.BatteryFull]: "61713",
  [BringgFontIcons.BatteryVerEmpty]: "61714",
  [BringgFontIcons.BatteryVerHalf]: "61715",
  [BringgFontIcons.BatteryVerQuarter]: "61716",
  [BringgFontIcons.BatteryVerThreeQuarters]: "61717",
  [BringgFontIcons.Bicycle]: "61718",
  [BringgFontIcons.Block]: "61719",
  [BringgFontIcons.BreakTo]: "61720",
  [BringgFontIcons.Bringg]: "61721",
  [BringgFontIcons.Bullseye]: "61722",
  [BringgFontIcons.Bus]: "61723",
  [BringgFontIcons.Busket]: "61724",
  [BringgFontIcons.CafeSolid]: "61725",
  [BringgFontIcons.Cafe]: "61726",
  [BringgFontIcons.Calendar]: "61727",
  [BringgFontIcons.Campaign]: "61728",
  [BringgFontIcons.Cancel]: "61729",
  [BringgFontIcons.Car]: "61730",
  [BringgFontIcons.Cart]: "61731",
  [BringgFontIcons.Cashier]: "61732",
  [BringgFontIcons.ChatBubble]: "61733",
  [BringgFontIcons.ChatBubbles]: "61734",
  [BringgFontIcons.Checklist]: "61735",
  [BringgFontIcons.ChevronLeft]: "61736",
  [BringgFontIcons.ChevronRight]: "61737",
  [BringgFontIcons.ChevronUp]: "61738",
  [BringgFontIcons.Chevron]: "61739",
  [BringgFontIcons.ChevronsEnd]: "61740",
  [BringgFontIcons.ChevronsStart]: "61741",
  [BringgFontIcons.CircleExclamation]: "61742",
  [BringgFontIcons.Circle]: "61743",
  [BringgFontIcons.ClockLight]: "61744",
  [BringgFontIcons.Clock]: "61745",
  [BringgFontIcons.CloseCircle]: "61746",
  [BringgFontIcons.Close]: "61747",
  [BringgFontIcons.Coins]: "61748",
  [BringgFontIcons.Colorize]: "61749",
  [BringgFontIcons.Columns]: "61750",
  [BringgFontIcons.Compass]: "61751",
  [BringgFontIcons.Completed]: "61752",
  [BringgFontIcons.ConnectedHub]: "61753",
  [BringgFontIcons.ControlTower]: "61754",
  [BringgFontIcons.Copy]: "61755",
  [BringgFontIcons.CreditCard]: "61756",
  [BringgFontIcons.Crew]: "61757",
  [BringgFontIcons.CsvFile]: "61758",
  [BringgFontIcons.Cube]: "61759",
  [BringgFontIcons.CustomerSdk]: "61760",
  [BringgFontIcons.Customer]: "61761",
  [BringgFontIcons.Cutoff]: "61762",
  [BringgFontIcons.DeliverySlots]: "61763",
  [BringgFontIcons.DeployedCodeHistory]: "61764",
  [BringgFontIcons.DesignServices]: "61765",
  [BringgFontIcons.Distance]: "61766",
  [BringgFontIcons.DistributionHub]: "61767",
  [BringgFontIcons.DocumenatationLink]: "61768",
  [BringgFontIcons.Dot]: "61769",
  [BringgFontIcons.Download]: "61770",
  [BringgFontIcons.Drag]: "61771",
  [BringgFontIcons.DriverHome]: "61772",
  [BringgFontIcons.DriversReturningToBase]: "61773",
  [BringgFontIcons.Drivers]: "61774",
  [BringgFontIcons.Dropoff]: "61775",
  [BringgFontIcons.Eco]: "61776",
  [BringgFontIcons.EditSquare]: "61777",
  [BringgFontIcons.Erase]: "61778",
  [BringgFontIcons.EventAvailable]: "61779",
  [BringgFontIcons.Expenses]: "61780",
  [BringgFontIcons.Export]: "61781",
  [BringgFontIcons.ExternalLink]: "61782",
  [BringgFontIcons.EyeOff]: "61783",
  [BringgFontIcons.Eye]: "61784",
  [BringgFontIcons.Feather]: "61785",
  [BringgFontIcons.FileAlt]: "61786",
  [BringgFontIcons.FileImport]: "61787",
  [BringgFontIcons.File]: "61788",
  [BringgFontIcons.FilterHdr]: "61789",
  [BringgFontIcons.FilterList]: "61790",
  [BringgFontIcons.FlatTire]: "61791",
  [BringgFontIcons.FloatingInventory]: "61792",
  [BringgFontIcons.ForkLeftRightBack]: "61793",
  [BringgFontIcons.Forward]: "61794",
  [BringgFontIcons.Fragile]: "61795",
  [BringgFontIcons.Freeze]: "61796",
  [BringgFontIcons.Functions]: "61797",
  [BringgFontIcons.Globe]: "61798",
  [BringgFontIcons.GoToLink]: "61799",
  [BringgFontIcons.Graph]: "61800",
  [BringgFontIcons.GroupBy]: "61801",
  [BringgFontIcons.Hamburger]: "61802",
  [BringgFontIcons.HandPanMove]: "61803",
  [BringgFontIcons.HandPointingUp]: "61804",
  [BringgFontIcons.Headset]: "61805",
  [BringgFontIcons.HeartFilled]: "61806",
  [BringgFontIcons.Heart]: "61807",
  [BringgFontIcons.Help]: "61808",
  [BringgFontIcons.Home]: "61809",
  [BringgFontIcons.Hourglass]: "61810",
  [BringgFontIcons.Hub]: "61811",
  [BringgFontIcons.InfoFilled]: "61812",
  [BringgFontIcons.Info]: "61813",
  [BringgFontIcons.Inventory]: "61814",
  [BringgFontIcons.Json]: "61815",
  [BringgFontIcons.Keyboard]: "61816",
  [BringgFontIcons.Launch]: "61817",
  [BringgFontIcons.Layers]: "61818",
  [BringgFontIcons.LeafEco]: "61819",
  [BringgFontIcons.LibraryBooks]: "61820",
  [BringgFontIcons.Link]: "61821",
  [BringgFontIcons.List]: "61822",
  [BringgFontIcons.Loader]: "61823",
  [BringgFontIcons.LocalPolice]: "61824",
  [BringgFontIcons.LocalShipping]: "61825",
  [BringgFontIcons.Location]: "61826",
  [BringgFontIcons.Lock]: "61827",
  [BringgFontIcons.Locker]: "61828",
  [BringgFontIcons.Logout]: "61829",
  [BringgFontIcons.Man]: "61830",
  [BringgFontIcons.ManageHistory]: "61831",
  [BringgFontIcons.MapTask]: "61832",
  [BringgFontIcons.Map]: "61833",
  [BringgFontIcons.Maximize]: "61834",
  [BringgFontIcons.MenuHorizontal]: "61835",
  [BringgFontIcons.Menu]: "61836",
  [BringgFontIcons.MessageMail]: "61837",
  [BringgFontIcons.Minimize]: "61838",
  [BringgFontIcons.Minus]: "61839",
  [BringgFontIcons.Monitor]: "61840",
  [BringgFontIcons.MyLocation]: "61841",
  [BringgFontIcons.NavigationUp]: "61842",
  [BringgFontIcons.Navigation]: "61843",
  [BringgFontIcons.NoteLight]: "61844",
  [BringgFontIcons.Notes]: "61845",
  [BringgFontIcons.Notification]: "61846",
  [BringgFontIcons.OpenInNew]: "61847",
  [BringgFontIcons.Optimize]: "61848",
  [BringgFontIcons.Order]: "61849",
  [BringgFontIcons.OrderedList]: "61850",
  [BringgFontIcons.Package]: "61851",
  [BringgFontIcons.Pallets]: "61852",
  [BringgFontIcons.ParkingLocation]: "61853",
  [BringgFontIcons.PartnerExchange]: "61854",
  [BringgFontIcons.Pause]: "61855",
  [BringgFontIcons.PdfFile]: "61856",
  [BringgFontIcons.Pencil]: "61857",
  [BringgFontIcons.PhoneAndroid]: "61858",
  [BringgFontIcons.Phone]: "61859",
  [BringgFontIcons.Pickup]: "61860",
  [BringgFontIcons.Planning]: "61861",
  [BringgFontIcons.Play]: "61862",
  [BringgFontIcons.Plus]: "61863",
  [BringgFontIcons.Power]: "61864",
  [BringgFontIcons.Preferences]: "61865",
  [BringgFontIcons.PreparationRestaurant]: "61866",
  [BringgFontIcons.Preperation]: "61867",
  [BringgFontIcons.Print]: "61868",
  [BringgFontIcons.PrompedMessage]: "61869",
  [BringgFontIcons.Puzzle]: "61870",
  [BringgFontIcons.Radar]: "61871",
  [BringgFontIcons.Recipt]: "61872",
  [BringgFontIcons.RedoArrow]: "61873",
  [BringgFontIcons.Redo]: "61874",
  [BringgFontIcons.Report]: "61875",
  [BringgFontIcons.Reschedule]: "61876",
  [BringgFontIcons.Revenues]: "61877",
  [BringgFontIcons.Reviews]: "61878",
  [BringgFontIcons.Rotate]: "61879",
  [BringgFontIcons.Route]: "61880",
  [BringgFontIcons.Ruler]: "61881",
  [BringgFontIcons.SaveAs]: "61882",
  [BringgFontIcons.Save]: "61883",
  [BringgFontIcons.Scanner]: "61884",
  [BringgFontIcons.Search]: "61885",
  [BringgFontIcons.SelectedOutline]: "61886",
  [BringgFontIcons.Selected]: "61887",
  [BringgFontIcons.Send]: "61888",
  [BringgFontIcons.SettingsSuggest]: "61889",
  [BringgFontIcons.Settings]: "61890",
  [BringgFontIcons.Share]: "61891",
  [BringgFontIcons.SheetWithDollar]: "61892",
  [BringgFontIcons.ShieldPerson]: "61893",
  [BringgFontIcons.ShowLess]: "61894",
  [BringgFontIcons.ShowMore]: "61895",
  [BringgFontIcons.SmallCircle]: "61896",
  [BringgFontIcons.SortAsc]: "61897",
  [BringgFontIcons.SortDesc]: "61898",
  [BringgFontIcons.Star]: "61899",
  [BringgFontIcons.StickyNote]: "61900",
  [BringgFontIcons.StopCircle]: "61901",
  [BringgFontIcons.Store]: "61902",
  [BringgFontIcons.Suffix]: "61903",
  [BringgFontIcons.Suitcase]: "61904",
  [BringgFontIcons.Support]: "61905",
  [BringgFontIcons.TakeoutDining]: "61906",
  [BringgFontIcons.TaskAlt]: "61907",
  [BringgFontIcons.TeamHome]: "61908",
  [BringgFontIcons.TeamParking]: "61909",
  [BringgFontIcons.Team]: "61910",
  [BringgFontIcons.TextBold]: "61911",
  [BringgFontIcons.TextItalic]: "61912",
  [BringgFontIcons.TextUnderline]: "61913",
  [BringgFontIcons.Ticket]: "61914",
  [BringgFontIcons.Traffic]: "61915",
  [BringgFontIcons.Trailer]: "61916",
  [BringgFontIcons.Trash]: "61917",
  [BringgFontIcons.Tree]: "61918",
  [BringgFontIcons.Truck]: "61919",
  [BringgFontIcons.Unassigned]: "61920",
  [BringgFontIcons.Unavailable]: "61921",
  [BringgFontIcons.UndoArrow]: "61922",
  [BringgFontIcons.Undo]: "61923",
  [BringgFontIcons.Unuser]: "61924",
  [BringgFontIcons.User]: "61925",
  [BringgFontIcons.Users]: "61926",
  [BringgFontIcons.VerificationCode]: "61927",
  [BringgFontIcons.Warehouse]: "61928",
  [BringgFontIcons.WarningCircle]: "61929",
  [BringgFontIcons.WarningNotFilled]: "61930",
  [BringgFontIcons.Warning]: "61931",
  [BringgFontIcons.Weight]: "61932",
  [BringgFontIcons.Wheel]: "61933",
  [BringgFontIcons.ZoomIn]: "61934",
  [BringgFontIcons.ZoomOut]: "61935",
};
